import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ParameterResult } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface FloorNumbersParams extends DefaultHttpHeaders {
  homeTypeCode?: string;
}

@Injectable()
export class FloorNumbersService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Service for obtaining floor numbers
   * Service for obtaining floor numbers
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Catalog/getComeroundFloorNumbers
   */
  floorNumbers(params: FloorNumbersParams): Observable<ParameterResult[]> {
    const queryParams = {
      homeTypeCode: params.homeTypeCode,
    };
    return this.get<ParameterResult[]>({
      suffix: '/comeround/catalog/floorNumbers',
      queryParams,
    });
  }
}
